import { useCurrentRoute } from '@office-start/component-context-service';
export var useOcidValue = function () {
    var route = useCurrentRoute();
    if ((route === null || route === void 0 ? void 0 : route.route) === 'Pwa') {
        return 'cmm8gnwxv06';
    }
    return 'cmmhp9cy416';
};
//# sourceMappingURL=useOcidValue.js.map